export const publicMotion = {
  duration: { instant: 0.1, micro: 0.16, interface: 0.24, panel: 0.32, scene: 0.56, ambient: 7 },
  ease: { standard: [0.2, 0, 0, 1] as const, reveal: [0.16, 1, 0.3, 1] as const },
  distance: { micro: 6, interface: 16, scene: 34 },
  stagger: { tight: 0.045, standard: 0.075, hero: 0.11 },
  astronaut: { floatY: 7, rotate: 1.25, parallax: 18 },
  spring: { interface: { type: 'spring' as const, stiffness: 360, damping: 34, mass: 0.9 } },
  viewport: { once: true, amount: 0.12 } as const,
} as const;

export const publicVariants = {
  page: {
    hidden: { opacity: 0, y: publicMotion.distance.micro },
    show: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -publicMotion.distance.micro },
  },
  reveal: {
    hidden: { opacity: 0, y: publicMotion.distance.interface, filter: 'blur(7px)' },
    show: { opacity: 1, y: 0, filter: 'blur(0px)' },
  },
  card: {
    hidden: { opacity: 0, y: 12, scale: 0.992 },
    show: { opacity: 1, y: 0, scale: 1 },
  },
  listItem: {
    hidden: { opacity: 0, y: 8 },
    show: { opacity: 1, y: 0 },
  },
  popover: {
    hidden: { opacity: 0, y: 6, scale: 0.985 },
    show: { opacity: 1, y: 0, scale: 1 },
    exit: { opacity: 0, y: 4, scale: 0.99 },
  },
  astronautEntrance: {
    hidden: { opacity: 0, y: 16, rotate: -1.25, scale: 0.985 },
    show: { opacity: 1, y: 0, rotate: 0, scale: 1 },
  },
} as const;

export function publicTransition(
  reducedMotion: boolean,
  duration: number = publicMotion.duration.interface,
) {
  return reducedMotion ? { duration: 0 } : { duration, ease: publicMotion.ease.reveal };
}
